export default "__VITE_ASSET__Bptmbdez__"